module.exports = __webpack_public_path__ + "img/refresh.aae49de0.svg";